export default {
  LOADER: 'LOADER',
  CLIENT: 'CLIENT',
  SERVICES: 'SERVICES',
};
